import React from 'react';

import { useAuthenticatedUser } from 'components/hooks/dataHooks';

import { InitiativeIcon } from 'assets/assetsV1/iconComponents';
import noInitiativesInsights from 'assets/assetsV1/illustrations/newIllustrations/noInitiativesInsights.svg';

import { TEAM_TYPE } from 'constants/ProjectConstants';
import { getTeamPageForInitiativesRoute } from 'constants/helper';
import { routes } from 'constants/routes';

import { SkeletonLoader } from 'uiToolkitV1/SkeletonLoader';

import { EmptySummaryCard } from '../../EmptyCard/EmptySummaryCard';
import { MySummaryCardTemplate } from '../MySummaryCardTemplate';
import { InitiativesAgGrid } from './components/InitiativesAgGrid';
import { useInitiativeTableDataQuery } from './hooks';

interface Props {}

const getURLHref = ({ teams = [] }) => {
  const personalTeam = teams?.find((team, index) => {
    if (team?.teamType === TEAM_TYPE.personal) {
      return team;
    }
  });
  const url = getTeamPageForInitiativesRoute({
    teamId: personalTeam?.id,
    teamName: 'My Initiatives',
    teamType: 'MY_INITIATIVES',
  });
  return url;
};

const InitiativesMySummaryAgGrid = (props: Props) => {
  const {
    user: { id, teams },
  } = useAuthenticatedUser();
  //   @ts-ignore
  const { data, isLoading } = useInitiativeTableDataQuery({
    attributeFilter: {
      filterConditions: [
        {
          type: 'NAME',
          operatorType: 'IN',
          data: [id],
        },
        {
          type: 'TYPE',
          operatorType: 'IN',
          data: ['TASK'],
        },
      ],
    },
    employeeId: id,
  });

  const firstThreeInitiatives = data?.computedData?.slice(0, 3) ?? [];

  if (isLoading) {
    return (
      // @ts-ignore
      <MySummaryCardTemplate showViewAllButton={false} Icon={InitiativeIcon} heading="Initiatives">
        <div style={{ marginTop: '16px' }}>
          <SkeletonLoader />
        </div>
      </MySummaryCardTemplate>
    );
  }

  if (!data?.computedData?.length) {
    return (
      <EmptySummaryCard
        Icon={InitiativeIcon}
        heading="Initiatives"
        description="Check here the list of all your ongoing & completed initiatives which will help you achieve any KR/objective. Write your first initiative."
        illustrationSrc={noInitiativesInsights}
        redirectUrl={routes.initiative.audit}
      />
    );
  }

  return (
    // @ts-ignore
    <MySummaryCardTemplate
      Icon={InitiativeIcon}
      heading="Initiatives"
      viewAllText="View All Initiatives"
      viewAllHref={getURLHref({ teams })}
    >
      <InitiativesAgGrid tableData={firstThreeInitiatives} />
    </MySummaryCardTemplate>
  );
};

export { InitiativesMySummaryAgGrid };
